import { z } from 'zod';

// the three modes are:
// - disable-debug: do not run debug mode (default)
// - no-write: do not write any data to the database (or ATS)
// - no-write-ats: write data to the database, but do not write to the ATS
// if writes are not performed to the database, the AI interviewer will re-process the applicant on subsequent requests
export const AIInterviewerDebugMode = z
  .enum(['disable-debug', 'no-write', 'no-write-ats'])
  .describe('AIInterviewerDebugMode');

export type AIInterviewerDebugMode = z.infer<typeof AIInterviewerDebugMode>;

export const AI_INTERVIEWER_DEBUG_MODE_DEFAULT: AIInterviewerDebugMode =
  'disable-debug';
